<div class="container">
  <div class="header">
    <h2 style="text-align: center">Select an Option</h2>
    <i class="link times icon" (click)="modal.deny(undefined)"></i>
  </div>
  <div class="option">
    <div class="login" (click)="onLogin()">
      <p>LOGIN TO PROCEED</p>
      <img src="assets/icons/Frame (4).svg" alt="data" />
    </div>
    <div class="login" (click)="onSignup()">
      <p>CREATE ACCOUNT TO PROCEED</p>
      <img src="assets/icons/Frame (4).svg" alt="data" />
    </div>
  </div>
</div>
